// Libs
import React from "react";
import { useQueryParams, StringParam } from "use-query-params";

// Styles
import { Container, Item, Link } from "./BreadcrumbStyle";

// i18n
import { useTranslation } from 'react-i18next';

import { allCategories } from '../../../newDropshipperApp/pages/search/staticCategories'
// Last children active
// Search QS always pinned at the end of the
// collection_id, keywords,category,subcategory

const Breadcrumb = ({ collections }) => {
  const { t } = useTranslation();
  // Managing state in URL query parameters with serialization
  const [query, setQuery] = useQueryParams({
    subcategory: StringParam,
    category: StringParam,
    keywords: StringParam,
    collection_id: StringParam
  });
  const { category, subcategory, keywords, collection_id } = query;

  const getCategory = () => {
    if (!category) return null;

    return allCategories().find( cat => cat.value === category )
  }

  const getSubCategory = () => {
    if (!category) return null;
    if (!subcategory) return null;

    return getCategory().subcategories.find( scat => scat.name === subcategory )
  }

  const getCollectionNameById = () => {
    if (collections.length > 0) {
      const selectedCollection = collections.find(
        collection => collection.id === collection_id
      );

      return selectedCollection ? selectedCollection.name : "";
    }
  };

  return (
    <Container>
      {(category || subcategory || keywords || getCollectionNameById()) && (
        <Item key="Home">
          <Link
            onClick={() =>
              setQuery(
                {
                  category: null,
                  subcategory: null,
                  keywords: null,
                  collection_id: null
                },
                "pushIn"
              )
            }
          >
            { t("Breadcrumb.Item.Home") }
          </Link>
        </Item>
      )}
      {category &&
        !collection_id && (
          <Item key="Category">
            <Link
              onClick={() =>
                setQuery(
                  {
                    subcategory: null,
                    keywords: null,
                    collection_id: null
                  },
                  "pushIn"
                )
              }
            >
              {getCategory().label}
            </Link>
          </Item>
        )}
      {subcategory &&
        !collection_id && (
          <Item key="Subcategory">
            <Link
              onClick={() =>
                setQuery({ keywords: null, collection_id: null }, "pushIn")
              }
            >
              {getSubCategory().label}
            </Link>
          </Item>
        )}
      {collection_id &&
        getCollectionNameById() && (
          <Item key="Collection">
            <Link
              onClick={() =>
                setQuery({ subcategory: null, keywords: null }, "pushIn")
              }
            >
              {getCollectionNameById()}
            </Link>
          </Item>
        )}
      {keywords && (
        <Item key="Keywords">
          { t("Breadcrumb.Item.Search") } <Link disabled>"{keywords}"</Link>
        </Item>
      )}
    </Container>
  );
};

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/Breadcrumb.js